import {DomainStore} from 'shared/store';
import {action, observable} from 'mobx';
import {types, endpoints} from 'main/tools';

class SurveysPageState {
  store = new DomainStore();
  @observable scope;

  @action async load() {
    await this.store._compose([
      endpoints.PAYROLL.NAVIGATION
    ]);

    this.scope = this.store._getSingle(types.NAVIGATION_SCOPE).tabs;
  }
}

export default SurveysPageState;
